import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TabData } from '../../models/ITabData';

@Component({
  selector: 'ff-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  /**
   * Options to display as tabs.
   * Use the TabData interface: { label: string; componentType: string; }
   * @internal
   */
  @Input() options: TabData[];

  /**
   * Emit a string to know which element should be displayed in the parent component
   * @internal
   */
  @Output() emitComponent = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {}

  emitValue = (elementType: string): void => {
    this.emitComponent.emit(elementType);
  }

}
